import React from 'react';
import { MenuItem, Select, InputLabel } from '@mui/material';
import { Languages } from '@beable/content-types';

interface LanguageSelectorProps {
    onChange: (e: any) => void;
    disabled?: boolean;
    lang?: Languages | undefined;
    labelText?: string;
}
  
export default function LanguageSelector({ onChange, disabled, lang, labelText }: LanguageSelectorProps) {
    return <>
    { labelText && (<InputLabel id="languagePickerLabel" htmlFor="languagePicker">{labelText}</InputLabel>) }
    <Select
        variant="outlined"
        labelId="languagePickerLabel"
        id="languagePicker"
        name="language"
        value={lang ?? ''}
        onChange={onChange}
        disabled={disabled}
        label={labelText}>
        {Object.keys(Languages).map(
          (e, i) => {
          const langValue = Object.values(Languages)[i];
          return <MenuItem value={langValue} key={e}>{e}</MenuItem>
})}
    </Select>
    </>;
}
